/**
 * Whether a stored URL can be turned into a link.
 *
 * `website`, `linkedin_url` and the `social_media` values are free text: the
 * import writes whatever LinkedIn had, and the settings page accepts what the
 * user types. "sito.it" and "mailto:x@y" both look like values and neither is a
 * link this page can render — the first navigates to `/company/:id/sito.it`,
 * the second is not a web address at all.
 *
 * Rejecting is the right answer rather than repairing: prefixing `https://` to
 * "sito.it" would assert a host nobody stated, and the page's whole rule is
 * that a missing datum hides its row (EP6).
 */
export const isRenderableUrl = (
  value: string | null | undefined,
): value is string => {
  if (!value) return false;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

/**
 * What to print for a link, when the URL itself is too long to read.
 * "https://www.novantalabs.com/careers/" reads better as "novantalabs.com".
 */
export const urlLabel = (value: string): string => {
  try {
    return new URL(value).hostname.replace(/^www\./, "");
  } catch {
    return value;
  }
};
